import { useEffect, useState } from "react";
import { API_URL, fetchWithToken } from "../../api/apiBase";
import { useAuthInfo } from "@propelauth/react";
// import SwaggerUI from "swagger-ui-react"
// import "swagger-ui-react/swagger-ui.css"

// ENDPOITNS ->
// json data: "/openapi.json"
// html: docs/
// how to react?

function Docs() {
    const { accessToken } = useAuthInfo();

    return (
        <iframe src={`${API_URL}/docs`}>
            {/*<div dangerouslySetInnerHTML={{__html: htmlDoc}}> </div>*/}
        </iframe>
    );
}

export default Docs;
